import React from "react";
// import PropTypes from "prop-types";
//
import { useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
// component, hooks
import AccordionMain from "../../../../../../common/components/accordion/AccordionMain";
import AccordionDetailChildren from "./AccordionDetailChildren";

const NodeCountDefNew = () => {
  // route,intl
  const intl = useIntl();

  // local state
  return (
    <Box mb={1}>
      <AccordionMain
        accordionProps={{}}
        darkMode
        summaryChildren={{
          text: intl.formatMessage({
            id: "sna.sidebar.filtertool.nodeCount.defineNew",
            defaultMessage: "節點數定義選項",
          }),
        }}
        detailsChildren={<AccordionDetailChildren />}
        detailsProps={{}}
      />
    </Box>
  );
};

NodeCountDefNew.propTypes = {};

NodeCountDefNew.defaultProps = {};

export default NodeCountDefNew;
